import styled from '@emotion/styled';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down.svg';
import { TextStyle } from 'styles/variables/mixins';
import { Colors } from 'styles/variables/colors';
import { Variables } from 'styles/variables/variables';

const { white, darkGray, red, lightGray, revampedPurple } = Colors;

export const DropdownPrompts = styled.p`
    ${TextStyle({ fontSize: '15px', fontWeight: '500', color: Colors.gray })}
    text-align: center;
`;

// for left dropdown
type DropdownProps = {
    isActive?: boolean;
    mobile?: boolean;
    desktopShadow?: boolean;
    dashboard?: boolean;
    clientProfile?: boolean;
    customStyleForSearchbar?: boolean;
    agreementPage?: boolean;
    onboarding?: boolean;
    purple?: boolean;
    width?: string;
};

export const LeftDropdownContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const LeftDropdownErrorMessage = styled.div`
    ${TextStyle({ fontSize: '14px', fontWeight: '400', color: red })};
    margin-left: 0.7rem;
`;

export const LeftDropdown = styled.div<DropdownProps>`
    ${TextStyle({ fontSize: '15px', fontWeight: '400' })}
    width: ${({
        clientProfile,
        dashboard,
        mobile,
        customStyleForSearchbar,
        agreementPage,
        onboarding,
        width,
    }) =>
        width
            ? width
            : onboarding || (mobile && !clientProfile && !dashboard && !agreementPage)
              ? '100%'
              : (customStyleForSearchbar && (dashboard || clientProfile || agreementPage)) ||
                  (mobile && (clientProfile || dashboard || agreementPage))
                ? '48%'
                : dashboard
                  ? '32%'
                  : '520px'};
    min-height: 36px;
    border: ${(props) =>
        props.purple
            ? props.mobile
                ? `1px solid ${revampedPurple}`
                : '1px solid #8353E2FF'
            : '1px solid #00a9c0ff'};

    border-radius: 6px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    line-height: 1.2;
    padding: 9px 12px;
    box-sizing: border-box;
    fill: ${darkGray};
    transition: all 110ms ease;
    background: ${white};
    outline: none;
    margin-left: ${(props) => (props.mobile ? '2px' : '0px')};
    box-shadow: ${(props) =>
        props.desktopShadow
            ? props.mobile
                ? '0px 0px 2px 3px #e8d4f4'
                : '0px 0px 2px 3px rgba(0, 169, 192, 0.4)'
            : ''};
    overflow: visible;
    position: relative;
`;

export const DropDownMenu = styled.ul<{ dashboardMenuMobile?: boolean }>`
    width: ${({ dashboardMenuMobile }) => (dashboardMenuMobile ? '' : '289px')};
    border-radius: 8px;
    border: 1px solid #f3f4f6ff;
    box-shadow: 0px 10px 20px -15px #171a1f;
    padding: 0.5rem;
    max-height: 275px;
    overflow-y: auto;
`;

export const DropdownIcon = styled(ArrowDownIcon)`
    fill: inherit;
    max-width: 12px;
    min-width: 12px;
    margin-left: 9px;
`;

//for left menu item
type MenuItemProps = {
    margin?: string;
    marginRight?: string;
};

export const MenuItem = styled.li<MenuItemProps>`
    ${TextStyle({ fontSize: '15px', fontWeight: '400', color: darkGray })};
    margin-left: ${(props) => (props.margin ? props.margin : '')};
    min-height: auto;
    text-decoration: none;
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    border-radius: 4px;
    cursor: pointer;
    :hover {
        background-color: #e7def9ff;
        ${TextStyle({ fontSize: '15px', fontWeight: '600', color: '#6025d8ff' })};
    }
`;

export const Img = styled.img`
    margin-right: 5px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: inline-block;
    object-fit: cover;
`;

export const Item = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    padding: 8px 12px;
    width: 100%;
`;

export const PlaceholderImg = styled.span`
    margin-right: 5px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: inline-block;
    object-fit: cover;
`;

export const Text = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    /* display: flex;
    justify-content: space-between; */
    width: 100%;
    line-height: 1.2;
    white-space: nowrap;
`;

export const SelectionContainer = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
`;

//for unread notifications dot
export const UnreadDot = styled.div`
    display: flex;
    align-self: flex-start;
    width: 8px;
    height: 8px;
    background-color: rgb(255, 166, 0);
    border-radius: 50%;
`;

//for longer explanation popovers
export const FakeInput = styled.div`
    ${TextStyle({ fontSize: '15px', fontWeight: '400', fontFamily: Variables.assistant })};
    padding: 20px;
    border: 1px solid ${lightGray};
    border-radius: 4px;
    margin-bottom: 1rem;
`;

export const SearchInput = styled.input`
    width: 100%;
    padding: 8px;
    border: none;
    border-bottom: 1px solid ${Colors.lightGray};
    outline: none;
    font-size: 14px;
`;

export const NoResults = styled.div`
    padding: 8px;
    text-align: center;
    color: ${Colors.darkGray};
    font-size: 14px;
`;
